/**
 * Collection-card financing badge picker (mirrors the PDP trust-strip logic).
 *
 * Each .csc-card-finance box holds a <klarna-placement> + a hidden Shop Pay
 * Installments message (<shopify-payment-terms> via {{ form | payment_terms }}).
 * Klarna is preferred ONLY when it renders an actual £ breakdown; above its
 * instalment limit Klarna shows a figure-less "Secure payment in seconds" promo,
 * so we surface the Shop Pay figure ("£X/mo at 0% APR") instead.
 */
(function () {
  if (window.__cscCardFinanceGuard) return;
  window.__cscCardFinanceGuard = true;

  function painted(el) {
    return !!el && (
      el.offsetHeight > 6 ||
      (el.shadowRoot && el.shadowRoot.childElementCount > 0) ||
      el.childElementCount > 0
    );
  }
  // True only when the widget has rendered an actual £ amount (a breakdown).
  function hasFigure(el) {
    if (!el) return false;
    var t = (el.shadowRoot ? el.shadowRoot.textContent : '') + ' ' + (el.textContent || '');
    return /£\s?\d/.test(t);
  }

  function evaluate() {
    document.querySelectorAll('.csc-card-finance').forEach(function (box) {
      var klarna = box.querySelector('.csc-card-finance__klarna, klarna-placement');
      var shoppay = box.querySelector('.csc-card-finance__shoppay');
      var shoppayEl = box.querySelector('shopify-payment-terms, shop-pay-installments-banner');
      var shoppayAvail = !!shoppayEl;
      var showKlarna = false, showShoppay = false;

      if (hasFigure(klarna)) {
        showKlarna = true;                      // Klarna shows a real breakdown → preferred
      } else if (painted(klarna)) {
        if (shoppayAvail) showShoppay = true;   // Klarna generic (no £) + Shop Pay has a figure
        else showKlarna = true;                 // keep the generic Klarna (better than nothing)
      } else if (shoppayAvail) {
        showShoppay = true;                     // Klarna not available; Shop Pay is
      }

      if (showKlarna) {
        if (klarna) klarna.style.display = 'block';
        if (shoppay) shoppay.style.display = 'none';
      } else if (showShoppay) {
        if (klarna) klarna.style.display = 'none';
        if (shoppay) shoppay.style.display = 'block';
      }
    });
  }

  // Klarna / Shop Pay hydrate asynchronously — re-check a few times.
  function schedule() { setTimeout(evaluate, 1200); setTimeout(evaluate, 3200); setTimeout(evaluate, 5500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
